const projectKey = import.meta.env.VITE_X_BLOCKS_KEY || '';

type ProjectStoreState = {
  selectedProject: {
    tenantId: string;
  };
};

const state: ProjectStoreState = {
  selectedProject: {
    tenantId: projectKey,
  },
};

export function useProjectStore(): ProjectStoreState;
export function useProjectStore<T>(selector: (state: ProjectStoreState) => T): T;
export function useProjectStore<T>(selector?: (state: ProjectStoreState) => T) {
  return selector ? selector(state) : state;
}
